import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

// Limited, opt-in testimonials from early Giftopay users.
// We keep this list intentionally short and honest — no stock photos or fabricated metrics.
const TESTIMONIALS = [
  {
    quote:
      "I sold a $200 Amazon card and was paid to PayPal in just under three hours. Rate was exactly what they quoted — no surprises at checkout.",
    name: "Daniel R.",
    role: "Verified seller",
    country: "🇺🇸",
  },
  {
    quote:
      "Clean dashboard, clear status updates. I sent an Apple iTunes card from Dubai and the AED hit my bank the same day. Support replied on WhatsApp in minutes.",
    name: "Yasmin A.",
    role: "Verified seller",
    country: "🇦🇪",
  },
  {
    quote:
      "I trade Steam codes regularly. The rate table is transparent and what's quoted is what gets paid. Interac arrived within the day each time.",
    name: "Marc L.",
    role: "Regular trader",
    country: "🇨🇦",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#00C853] font-semibold">What sellers say</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B3C5D] mt-3 tracking-tight">
            A small sample of feedback.
          </h2>
          <p className="mt-3 text-slate-600 max-w-xl mx-auto text-sm">
            Three recent quotes shared by verified Giftopay sellers. We don&apos;t use stock photos
            or fabricated reviews.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="rounded-2xl border border-slate-200 bg-white p-6 card-hover"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-6 h-6 text-[#00C853]" />
              <p className="mt-4 text-sm leading-relaxed text-slate-700">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-slate-100">
                <div className="w-10 h-10 rounded-full bg-[#0B3C5D] text-white flex items-center justify-center font-display font-bold text-sm">
                  {t.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-display font-bold text-sm text-[#0B3C5D]">
                    {t.name} <span className="ml-0.5">{t.country}</span>
                  </p>
                  <p className="text-[11px] text-slate-500">{t.role}</p>
                </div>
                <div className="flex items-center gap-0.5 text-[#00C853]">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-current" />
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
